/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Platform values for Freewheel ad calls
 * Used in site section ID (csid) construction for ad targeting.
 * Determined by device type check (isDesktop()).
 *
 * @example
 * // Used in AbstractFreewheelClass.getPlatform():
 * const platform = this.isDesktop()
 *   ? FreewheelPlatform.DESKTOP
 *   : FreewheelPlatform.MOBILE;
 *
 * @see {@link AbstractFreewheelClass.createSiteSectionId}
 */
export enum FreewheelPlatform {
	/**
	 * @description Desktop platform (web browsers on desktop computers)
	 */
	DESKTOP = 'desktop',

	/**
	 * @description Mobile platform (mobile web browsers, tablets)
	 */
	MOBILE = 'mobile',
}